import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import type React from 'react';

interface ErrorStateProps {
  title: string;
  message: string;
  additionalInfo?: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ title, message, additionalInfo }) => {
  return (
    <Card sx={{ borderRadius: 3, p: 3 }}>
      <Typography variant="h6" color="error" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        {message}
      </Typography>
      {additionalInfo && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 2,
          }}
        >
          {additionalInfo}
        </Typography>
      )}
    </Card>
  );
};

export default ErrorState;
